import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as gameSelectors from '../../../Core/Game/game.selectors'
import * as selectors from '../pointsManager.selectors'

/**
 *  PointsAlert Component.
 */
const PointsAlert = ({ values, position }) => {
  if (!values) {
    return null
  }

  const { value, icon, style } = values
  if (!value) {
    return null
  }

  let st = {
    ...style,
    position: position ? 'absolute' : null,
    top: position ? (position.y > window.innerHeight * 0.9 ? position.y - 30 : position.y) : null,
    left: position ? (position.x > window.innerWidth * 0.9 ? position.x - 80 : position.x) : null,
  }

  let className = style.antimatter ? 'antimateria' : ''

  return (
    <div className={`toast active ${className}`} style={st}>
      <span className={icon}> </span>
      <span className="text"> {value}</span>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    position: gameSelectors.getCursorPosition(state),
    values: selectors.getValues(state),
  }
}

PointsAlert.propTypes = {
  values: PropTypes.object,
  position: PropTypes.object,
}

export default connect(mapStateToProps)(PointsAlert)
